import { BaseTabs } from 'app/components/common/BaseTabs'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { useGetNewTumRegisterTotalStatus } from 'app/react-query/hook/newTumRegister'
import React, { useMemo, useState } from 'react'
import {
  LabelComponent,
  TabKeysEnum,
} from '../EventManagement/RegisterActivity/components'
import ApproveUnionMembersTable from './components/ApproveUnionMembersTable'
import * as S from './styles'
import { ENewTumRegisterStatus } from './type'
import { BaseCol } from 'app/components/common/BaseCol'
import { ReviewTumModal } from './components/ReviewTumModal'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { PermissionEnum } from 'app/common/enum'

const NewMemberDeclarationLayout: React.FC = () => {
  const [tab, setTabs] = useState(TabKeysEnum.WAITING)
  const { verifyPermission, user } = useVerifyPermission()

  const { data } = useGetNewTumRegisterTotalStatus({ userId: user?.id })

  const isReviewTum = useMemo(() => {
    return verifyPermission(PermissionEnum.CreateNewTumRegister)
  }, [user])

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={'Khai báo đoàn viên công đoàn'}
        rightComponent={
          <>
            {isReviewTum ? (
              <BaseCol>
                <ReviewTumModal />
              </BaseCol>
            ) : null}
          </>
        }
      />

      <SectionBase>
        <BaseTabs
          onChange={ta => setTabs(ta as TabKeysEnum)}
          items={[
            {
              key: ENewTumRegisterStatus?.WAITING,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.WAITING}
                  label="Đang chờ phê duyệt"
                  count={data?.[ENewTumRegisterStatus?.WAITING]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.WAITING}
                />
              ),
            },
            {
              key: ENewTumRegisterStatus?.ACCEPTED,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.ACCEPTED}
                  label="Đã phê duyệt"
                  count={data?.[ENewTumRegisterStatus?.ACCEPTED]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.ACCEPTED}
                />
              ),
            },
            {
              key: ENewTumRegisterStatus?.REJECTED,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.REJECTED}
                  label="Đã từ chối"
                  count={data?.[ENewTumRegisterStatus?.REJECTED]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.REJECTED}
                />
              ),
            },
            {
              key: ENewTumRegisterStatus?.CANCELED,
              label: (
                <LabelComponent
                  tabActive={tab}
                  tabKey={TabKeysEnum.CANCELED}
                  label="Đã huỷ"
                  count={data?.[ENewTumRegisterStatus?.CANCELED]}
                />
              ),
              children: (
                <ApproveUnionMembersTable
                  status={ENewTumRegisterStatus.CANCELED}
                />
              ),
            },
          ]}
        />
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default NewMemberDeclarationLayout
